import React from 'react';

import withWindowResize from '../../../../ui/components/window-resize';

class BlogAdBanner extends React.Component{

    constructor(props){
        super(props);
        this.iframeRef = React.createRef();
        const {bannerMeta} = this.props || {};
        const {categories, tags} = bannerMeta || {};
        this.state = {
            bannerCategory: bannerMeta ? BlogAdBanner.getCategory(categories, tags) : null,
        }
    }

    static CATEGORY_MAPS = {
        'smb': {
            'business': 1,
            'tech-at-work': 1,
            'business-trends': 1,
            'smb': 1,
            'small-business': 1,
            'enterprise': 1
        },
        'gaming': {
            'gaming': 1,
            'hp-omen': 1
        },
        'workstations':{
            'tech-at-work': 1,
            'techatwork': 1
        }
    }

    componentDidMount(){
        if(this.evaluateScreenSize()){
            this.createAdElement();
        }
    }

    static getDerivedStateFromProps(nextProps, prevState){
        let {categories, tags} = nextProps.bannerMeta || {};
        let bannerCategory = BlogAdBanner.getCategory(categories, tags);
        // if it's a new category, set loaded=false. 
        // componentDidUpdate will take care of determining whether to load the banner if the browser has the correct screen width
        if(bannerCategory !== prevState.bannerCategory){
            return {
                bannerCategory,
                loaded: false
            }
        }

        return null;
    }

    /** only re-render if the banner hasn't been loaded yet */
    shouldComponentUpdate(nextProps, nextState){
        return !nextState.loaded;
    }

    componentDidUpdate(prevProps, prevState){
        let {loaded} = this.state;
        if(!loaded && this.evaluateScreenSize()){
            this.createAdElement();
        }
    }

    static getCategory = (categories, tags) => {
        let isBusiness   = BlogAdBanner.CATEGORY_MAPS['smb'];
        let isGaming     = BlogAdBanner.CATEGORY_MAPS['gaming'];
        let isTechAtWork = BlogAdBanner.CATEGORY_MAPS['workstations'];
        let category;
        let tagsAndCategories = (Array.isArray(categories) ? categories : [])
                                .concat(Array.isArray(tags) ? tags : [])
        for(let cat of tagsAndCategories){
            if( isTechAtWork[cat] ){
                return 'workstations';
            }
            if( isBusiness[cat] ){
                category = 'smb';
            }
            else if(isGaming[cat]){
                category = category || 'gaming';
            }
        }
        
        return category || 'default';
    }

    getScriptTemplate = (category) => `
        <head></head>
        <body style="padding:0; margin:0; width:100%; overflow:hidden">
        <ins class='dcmads' style='display:inline-block;width:300px;height:250px'
            data-dcm-placement='N5823.3620129HP1/B24455230.278813019'
            data-dcm-rendering-mode='script'
            data-dcm-https-only
            data-dcm-resettable-device-id=''
            data-dcm-app-id=''
            data-dcm-keywords='${category}'>
            <script src='https://www.googletagservices.com/dcm/dcmads.js'></script>
        </ins>
        </body>
    `;

    createAdElement = () => {
        try{
            this.setState({loaded: true}, () => {
                this.addScriptToAdElement();
            })
        }catch(e){}
    }

    addScriptToAdElement = () => {
        let {bannerCategory} = this.state;
        this.iframeRef.current.contentWindow.document.open();
        this.iframeRef.current.contentWindow.document.write(
            this.getScriptTemplate(bannerCategory)
        );
        this.iframeRef.current.contentWindow.document.close();
    }

    evaluateScreenSize = () => {
        let { customBreakpoints, type, breakpoint } = this.props;
        let device;
        try{
            device = customBreakpoints[breakpoint || 'blog-v2-list'];
        }catch(e){}
        return (device === 'desktop' || device === 'mobile') && device === type;
    }

    render(){
        return <iframe className="blog-ad-image" ref={this.iframeRef} />;
    }
}

export default withWindowResize(BlogAdBanner);